/* eslint-disable @angular-eslint/use-lifecycle-interface */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/member-ordering */
import { ApplicationRef, Component, ComponentFactory, ComponentFactoryResolver, EventEmitter, Injector, Input, OnChanges, OnInit, SimpleChanges, ViewEncapsulation } from '@angular/core';
import { MapsService } from 'app/modules/maps/maps.service';
import * as L from 'leaflet';
import * as R from 'leaflet-responsive-popup';
import 'leaflet.locatecontrol';
import _ from 'lodash';
import moment from 'moment';
import { env } from 'process';
import { antPath } from 'leaflet-ant-path';
import { environment } from 'environments/environment';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { RouteOriginDestinationPopupComponent } from '../route-origin-destination-popup/route-origin-destination-popup.component';
import { RouteJobPopupComponent } from '../route-job-popup/route-job-popup.component';
import { Subscription } from 'rxjs';
import { CreateRouteService } from '../create-route.service';
const H = window['H'];

@Component({
  selector: 'app-create-route-form-map',
  templateUrl: './create-route-form-map.component.html',
  styleUrls: ['./create-route-form-map.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class CreateRouteFormMapComponent implements OnInit, OnChanges {

  @Input() timezone?: string = moment.tz.guess();
  @Input() panMap?: any[];
  @Input() jobs: Array<any>;
  @Input() data: any;


  isMapLoading: boolean = true;
  activeGeoCords: number[];
  markerCluster: any;
  platform = new H.service.Platform({
    apikey: environment.hereMapKey
  });

  currentTitleType: string = 'DEFAULT';
  routeMapSubscription: Subscription;

  private map: any;
  private mapTileUrl: string = window['mapTileUrl'];
  private tileLayer: any;
  private routeLayerGroup: any;
  private rotateControl: any;

  constructor(
    private _MapService: MapsService,
    private _resolve: ComponentFactoryResolver,
    private _injector: Injector,
    private _appRef: ApplicationRef,
    private utilityService: UtilityService,
    private createRouteService: CreateRouteService
  ) { }

  private compilePopup(component, onAttach): any {
    const compFactory: ComponentFactory<Component> = this._resolve.resolveComponentFactory(component);
    const compRef = compFactory.create(this._injector);
    if (onAttach) { onAttach(compRef); }

    this._appRef.attachView(compRef.hostView);
    compRef.onDestroy(() => this._appRef.detachView(compRef.hostView));

    const div = document.createElement('div');
    div.appendChild(compRef.location.nativeElement);
    return div;
  }

  private initMap(is_coords: boolean,delay: number = 0): void {
   setTimeout(() => {
    let center; let zoom;
    if (is_coords) {
      center = this.activeGeoCords;
      zoom = 11;
    } else {
      center = [40.6000135, -25.2314079];
      zoom = 3;
    }
    this.map = L.map('map-create-route', {
      center: center,
      zoom: zoom,
      zoomControl: false,
      attributionControl: true
    });
    L.control.zoom({ position: 'bottomright' }).addTo(this.map);
    this.markerCluster = L.markerClusterGroup({
      animate: true,
      animateAddingMarkers: true,
      chunkedLoading: true
    });
   const locateControl =  L.control.locate({
      position: 'bottomright',
      drawCircle: false,
      follow: false,
      setView: false,
      icon: 'ti ti-current-location',
      title:'Current Location',
      metric: false,
      maxZoom:15,
      autoStart: false
    }).addTo(this.map);

    const locateIcon = locateControl._container.querySelector('.leaflet-bar-part');
    locateIcon.title = 'Current Location';
    locateIcon.addEventListener('click', () => {
      locateControl.start();
      locateControl.options.setView = true;
      locateControl.options.showPopup = false;
    });
    this.map.on('locationfound', (e) => {
      if (locateControl.options.setView) {
        this.map.setView(e?.latlng, 15);
        locateControl.options.setView = false;
        locateControl.options.showPopup = false;
      }
    });
    this.tileLayer = L.tileLayer(this.mapTileUrl, { styleId: 997, edgeBufferTiles: 5 }).addTo(this.map);
    this.map.whenReady(() => {
      this.isMapLoading = false;
    });
    this.getRoute();
    // eslint-disable-next-line prefer-arrow/prefer-arrow-functions
    setTimeout(function(this) {
      window.dispatchEvent(new Event('resize'));
    }, 500);
    setTimeout(() => {
      this.map.invalidateSize();
    }, 100);
   }, delay);
  }
  reloadMap(): void {
    this.map.setView(this.map.getCenter(), this.map.getZoom());
  }


  getRoute(delay: number = 0): void {
  setTimeout(() => {
    this.routeLayerGroup = L.layerGroup();
    const routeDetails = { ...this.data };
    const color = routeDetails?.color?.hex ? '#' + routeDetails.color.hex : routeDetails?.color;
    let startLocation = [];
    let endLocation = [];
    let viaLocation = [];

    if (this.jobs?.length > 0) {
      viaLocation = this.jobs.map((job: any) => job?.customer_address?.geo_cordinates?.join(','));
      this.jobs.forEach((job: any, jobIndex: any)=>{
        const location = [...job?.customer_address?.geo_cordinates];
        const jobLocationData = { job_name: job.job_title, color: color, customer_address: { ...job.customer_address },
        customer:{customer_first_name: job?.organization?.organization_name}};
        const jobLocationMarkerComponent: any = this.compilePopup(RouteJobPopupComponent, (c) => { c.instance.data = { type: 'ORIGIN', data: jobLocationData }; });
        const jobLocationMarkerPopup = R.responsivePopup({ minWidth: 280, offset: [5, -35] }).setContent(jobLocationMarkerComponent);
        const originIcon = L.divIcon({
          className: 'custom-div-icon',
          html: this._MapService.getRouteJobIcon(color, jobIndex+1),
          iconSize: [30, 42],
          iconAnchor: [15, 42]
        });
        L.marker(location, {
          icon: originIcon
        }).bindPopup(jobLocationMarkerPopup).addTo(this.routeLayerGroup);
      });
    }

    const reloadIconExists = document.querySelector('.navigateToHome');
    if (routeDetails.start_location_value !== '') {
      startLocation = [routeDetails?.start_location?.latitude, routeDetails?.start_location?.longitude];
      const startLocationData = { route_name: routeDetails.recurring_route_name, color: color, start_location: routeDetails.start_location_value };
      const homeMarkerComponent: any = this.compilePopup(RouteOriginDestinationPopupComponent, (c) => { c.instance.data = { type: 'ORIGIN', data: startLocationData }; });
      const homeMarkerPopup = R.responsivePopup({ minWidth: 280, offset: [5, -35] }).setContent(homeMarkerComponent);
      const originIcon = L.divIcon({
        className: 'custom-div-icon',
        html: this._MapService.getRouteHomeIcon(color),
        iconSize: [30, 42],
        iconAnchor: [15, 42]
      });
      L.marker(startLocation, {
        icon: originIcon
      }).bindPopup(homeMarkerPopup).addTo(this.routeLayerGroup);


      if (!reloadIconExists) {
        this.rotateControl = L.control({
          position: 'bottomright',
        });
        // eslint-disable-next-line @typescript-eslint/explicit-function-return-type
        this.rotateControl.onAdd = () => {
          const div = L.DomUtil.create('div', 'leaflet-bar leaflet-control');
          div.innerHTML = '<a title="Navigate to home" class="navigateToHome ti ti-home"></a>';
          const reloadIcon = div.querySelector('.navigateToHome');
          reloadIcon.addEventListener('click', () => {
            this.map.setView(startLocation, 15);
          });
          return div;
        };
          this.map?.addControl(this.rotateControl);
      }
    }

    if (routeDetails.start_location_value === '' && reloadIconExists) {
      reloadIconExists.remove();
    }

    if (routeDetails.end_location_value !== '') {
      endLocation = [routeDetails?.end_location?.latitude, routeDetails?.end_location?.longitude];
      const endLocationData = { route_name: routeDetails.recurring_route_name, color: color, end_location: routeDetails.end_location_value };
      const destinationMarkerComponent: any = this.compilePopup(RouteOriginDestinationPopupComponent, (c) => { c.instance.data = { type: 'DESTINATION', data: endLocationData }; });
      const destinationMarker = R.responsivePopup({ minWidth: 280, offset: [5, -35] }).setContent(destinationMarkerComponent);
      const originIcon = L.divIcon({
        className: 'custom-div-icon',
        html: this._MapService.getDestinationIcon(color),
        iconSize: [40, 52],
        iconAnchor: [15, 42]
      });
      L.marker(endLocation, {
        icon: originIcon
      }).bindPopup(destinationMarker).addTo(this.routeLayerGroup);
    }

    if (this.jobs.length > 1 || (routeDetails.start_location_value !== '' && routeDetails.end_location_value !== '')
    || ((routeDetails.start_location_value !== '' || routeDetails.end_location_value !== '') && this.jobs.length > 0)
    ) {

      const routingParameters = {
        'routingMode': 'fast',
        'transportMode': this.data?.transport_mode?.toLowerCase(),
        'origin': null,
        'spans': 'duration,baseDuration,length',
        'via': new H.service.Url.MultiValueQueryParameter(viaLocation),
        'return': 'polyline',
        'destination': null
      };

      if (startLocation.length > 0) {
        routingParameters['origin'] = startLocation?.join(',');
      } else if (viaLocation?.length) {
        routingParameters['origin'] = viaLocation[0];
      }

      if (endLocation.length > 0) {
        routingParameters['destination'] = endLocation?.join(',');
      } else if (viaLocation?.length) {
        routingParameters['destination'] = viaLocation[viaLocation?.length - 1];
      }
      if (!this.utilityService.isEmptyOrUndefined(routingParameters.destination)) {
        const router = this.platform.getRoutingService(null, 8);
        router.calculateRoute(routingParameters, (data: any) => {
          if (data?.routes[0]?.['sections']) {
            const sections = data.routes[0]['sections'];
            sections.forEach((section) => {
              const linestring = H.util.flexiblePolyline.decode(section.polyline);
              const antPolyline = antPath(linestring.polyline, {
                'delay': 600,
                'color': color,
                'pulseColor': color
              });
              antPolyline.pause();
              antPolyline.addTo(this.routeLayerGroup);
            });
          }
        },
          (error: any) => {
          });
      }
    }
    this.map?.addLayer(this.routeLayerGroup);
  }, delay);
  }

  ngOnInit(): void {
    this.routeMapSubscription =  this.createRouteService.routeMapData.subscribe((data: any) => {
     if(data){
      if(data.panJob === false){
        this.handleMapChanges(data);
      }else{
      this.panJob(data?.data?.customer_address?.geo_cordinates);
      }
     }
    });
  }

  ngOnChanges(changes: SimpleChanges): void {
    if ('panMap' in changes) {
      this.panMapView(this.panMap);
    }
  }

  panMapView(geoCords: any[], zoomLevel: number = 13): void {
    if (geoCords?.length === 2 && this.map) {
      this.map.setView(geoCords, zoomLevel);
    }
  }

  panJob(geoCords: any[], zoomLevel: number = 16): void {
    if (geoCords?.length === 2 && this.map) {
      this.map.setView(geoCords, zoomLevel);
    }
  }

  handleMapChanges(data: any): void{
    this.data = data.data;
    this.jobs = data.jobs;
    if(this.map?.removeLayer && this.routeLayerGroup){
      this.map?.removeLayer(this.routeLayerGroup);
    }
    this.routeLayerGroup = '';
    this.getRoute();
  }

  ngAfterViewInit(): void {
    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition((res) => {
        if (res?.coords?.latitude && res?.coords?.longitude) {
          this.activeGeoCords = [res.coords.latitude, res.coords.longitude];
          this.initMap(true);
        }
      }, (err) => {
        this.initMap(false);
      });
    }

  }

  ngOnDestroy(): void {
    if(this.rotateControl){
      this.map?.removeControl(this.rotateControl);
    }
    if(this.map?.off){
      this.map.off();
    }
    if(this.map?.remove){
      this.map.remove();
    }
    if (this.routeMapSubscription?.unsubscribe) {
      this.routeMapSubscription?.unsubscribe();
    }
  }

}
